import { render, staticRenderFns } from "./OnboardingAdditionalData.vue?vue&type=template&id=2137c00c&scoped=true&"
import script from "./OnboardingAdditionalData.vue?vue&type=script&lang=js&"
export * from "./OnboardingAdditionalData.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAdditionalData.vue?vue&type=style&index=0&id=2137c00c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137c00c",
  null
  
)

export default component.exports